import { useCallback, useRef } from 'react';
import { call } from 'utils';

const usePropsCallback = callback => {
  const ref = useRef();
  ref.current = callback;

  return useCallback((...args) => call(ref.current, ...args), []);
};

export default usePropsCallback;
